import { render, staticRenderFns } from "./daily_profit.vue?vue&type=template&id=da23982c&scoped=true&"
import script from "./daily_profit.vue?vue&type=script&lang=js&"
export * from "./daily_profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da23982c",
  null
  
)

export default component.exports